import React from 'react';
import { createRefetchContainer, graphql } from 'react-relay';
import DrawerGridItemContainer from '../common/drawer/DrawerGridItemContainer';
import DrawerGridItemHeading from '../common/drawer/DrawerGridItemHeading';
import { createQueryRendererProgressV2 } from '../common/QueryRendererProgressV2';
import { VerticalTableWidget } from '../common/VerticalTableWidget';
import { deepCoalesce } from '../../common/helpers';
import EnumValue from '../common/EnumValue';
import { toLocal } from '../../helpers/ID';
import TableFieldMeta from '../../common/TableFieldMeta';
import TransferApprovalCell from '../common/TransferApprovalCell';
import EditableAmount from './cashTransferRequestList/EditableAmount';
import withSuspense from '../common/table/Suspention';


function CashTransferRequestDetailsFormBase(props) {
  const {
    relay,
    filter,
    viewer,
  } = props;
  filter.setRelay(relay);

  const EditTransferCashDialog = (process.env.DEPLOYMENT_CODE === 'UK')
    ? withSuspense(React.lazy(() => import('./uk/EditPositionTransferCashAmountDialog')))
    : (() => null);

  const [showEditDialog, setShowEditDialog] = React.useState(false);
  const ctr = deepCoalesce(viewer, ['cashTransferRequests', 'edges', 0, 'node']);
  return (
    <DrawerGridItemContainer>
      <DrawerGridItemHeading heading="Cash Transfer Request Details" />
      <VerticalTableWidget
        columnMeta={[
          ['Created At', TableFieldMeta.createdAt.accessor],
          // ['Amount', () => <Price currency={ctr.currency}>{ctr.amount}</Price>],
          ['Amount', () => <EditableAmount cashTransferRequest={ctr} onEdit={() => setShowEditDialog(true)} />],
          ['Transaction', () => ctr.cashTransfer && toLocal(ctr.cashTransfer.brokerActivity.id)],
          ['Type', () => <EnumValue enumType="CashTransferRequestSubtype" enumValue={ctr.subtype} />],
          ['Contra Party', () => <EnumValue enumType="ContraParty" enumValue={ctr.contraParty} />],
          ['Approved/Cancelled', TransferApprovalCell.updatedAtMeta.accessor],
          // ['Contra Only', () => (contraOnly ? 'Yes' : 'No')],
          // ['Inverse batch', node => node.inverseBatch && toLocal(batch.inverseBatch.id)],
          // ['Contra batch', node => node.contraBatch && toLocal(batch.contraBatch.id)],
          // ['Created At', node => (<DateTime>{node.createdAt}</DateTime>)],
        ]}
        // columnMeta={[]}
        dataNode={ctr}
        xs={12}
        showHeadings={false}
      />

      {
        ctr.batch && (
          <VerticalTableWidget
            columnMeta={[
              ['Created At', TableFieldMeta.createdAt.accessor],
              ['Name', 'name'],
              ['ID', () => toLocal(ctr.batch.id)],
            ]}
            // columnMeta={[]}
            dataNode={ctr.batch}
            xs={12}
            title="Batch"
            showHeadings={false}
          />
        )
      }

      {
        ctr.sourceCashTransferRequest && (
          <VerticalTableWidget
            columnMeta={[
              ['Created At', TableFieldMeta.createdAt.accessor.accessor],
              ['ID', () => toLocal(ctr.sourceCashTransferRequest.id)],
              ['Custodian', 'custodian'],
            ]}
            // columnMeta={[]}
            dataNode={ctr.sourceCashTransferRequest}
            xs={12}
            title="Source Cash Transfer Request"
            showHeadings={false}
          />
        )
      }

      <EditTransferCashDialog
        transfer={ctr}
        showDialog={showEditDialog}
        onHideDialog={(isSuccess) => {
          setShowEditDialog(false);
          if (isSuccess) props.relay.refetch();
        }}
      />


    </DrawerGridItemContainer>
  );
}

const query = graphql`
  query CashTransferRequestDetailsFormBaseQuery(
    $cashTransferRequestId: ID!
  )  {
    viewer {
      ...CashTransferRequestDetailsFormBase_viewer
      @arguments(
        cashTransferRequestId: $cashTransferRequestId
      )
    }
  }
`;

const container = createRefetchContainer(
  CashTransferRequestDetailsFormBase,
  {
    viewer: graphql`
      fragment CashTransferRequestDetailsFormBase_viewer on Query  
      @argumentDefinitions(
        cashTransferRequestId: {type: ID, defaultValue: null }
      ){
        cashTransferRequests (
          id: $cashTransferRequestId
        ) {
          edges {
            node {
              id
              createdAt
              updatedAt
              subtype
              amount
              custodian
              currency
              blocked
              status
              contraParty

              batch {
                createdAt
                id
                name
                inverseBatch {
                  id
                  name
                }
              }
              
#              sourceCashTransferRequest {
#                createdAt
#                id
#                custodian
#                amount
#              }

              cashtransferrequestapprovalSet {
                edges {
                  node {
                    approvedAt
                    approvedBy {
                      fullName
                    }
                  }
                }
              }

              cashTransfer {
                id
                brokerActivity {
                  id
                }
              }
            }
          }
        }
      }
    `,
  },
  query,
);

export default createQueryRendererProgressV2(
  query,
  container,
  {},
  ({ getCashTransferRequestId }) => ({ cashTransferRequestId: getCashTransferRequestId() }),
);
